import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FileText } from "lucide-react";

export function DocPicker({ value, onChange, placeholder, testId, exclude }) {
  const { t } = useI18n();
  const [docs, setDocs] = useState([]);
  useEffect(() => { api.get("/documents").then((r) => setDocs(r.data.filter((d) => d.analysis))); }, []);
  const list = docs.filter((d) => d.id !== exclude);
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className="rounded-xl"><SelectValue placeholder={placeholder || t("select_document")} /></SelectTrigger>
      <SelectContent>
        {list.length === 0 && <div className="px-3 py-2 text-sm text-slate-400">{t("no_analyzed_docs")}</div>}
        {list.map((d) => (
          <SelectItem key={d.id} value={d.id}>
            <span className="flex items-center gap-2">
              <FileText className="h-3.5 w-3.5 text-brandblue" />
              <span className="truncate">{d.original_filename}</span>
              {(d.analysis?.insurance_type || d.analysis?.carrier) && (
                <span className="ml-1 rounded-md bg-slate-100 px-1.5 py-0.5 text-[11px] text-slate-500">
                  {[d.analysis?.insurance_type, d.analysis?.carrier].filter(Boolean).join(" · ")}
                </span>
              )}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
